import { render, staticRenderFns } from "./ChoiceQuestionDescription.vue?vue&type=template&id=4d86be64&scoped=true"
import script from "./ChoiceQuestionDescription.vue?vue&type=script&lang=js"
export * from "./ChoiceQuestionDescription.vue?vue&type=script&lang=js"
import style0 from "./ChoiceQuestionDescription.vue?vue&type=style&index=0&id=4d86be64&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d86be64",
  null
  
)

export default component.exports